module.exports = __webpack_public_path__ + "img/p2-16.005b3f50.png";